import { render } from "./AIChat.vue?vue&type=template&id=78735d44&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"

import "./AIChat.vue?vue&type=style&index=0&id=78735d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78735d44"]])

export default __exports__